/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const SERVICES_ADD_REQUEST = 'SERVICES_ADD_REQUEST';
export const SERVICES_ADD_REQUEST_SUCCESS = 'SERVICES_ADD_REQUEST_SUCCESS';
export const SERVICES_ADD_REQUEST_FAILURE = 'SERVICES_ADD_REQUEST_FAILURE';

export const SERVICES_FETCH_REQUEST = 'SERVICES_FETCH_REQUEST';
export const SERVICES_FETCH_REQUEST_SUCCESS = 'SERVICES_FETCH_REQUEST_SUCCESS';
export const SERVICES_FETCH_REQUEST_FAILURE = 'SERVICES_FETCH_REQUEST_FAILURE';

export const SERVICES_UPSERT_REQUEST = 'SERVICES_UPSERT_REQUEST';
export const SERVICES_UPSERT_REQUEST_SUCCESS = 'SERVICES_UPSERT_REQUEST_SUCCESS';
export const SERVICES_UPSERT_REQUEST_FAILURE = 'SERVICES_UPSERT_REQUEST_FAILURE';

export const SERVICES_DELETE_REQUEST = 'SERVICES_DELETE_REQUEST';
export const SERVICES_DELETE_REQUEST_SUCCESS = 'SERVICES_DELETE_REQUEST_SUCCESS';
export const SERVICES_DELETE_REQUEST_FAILURE = 'SERVICES_DELETE_REQUEST_FAILURE';

export const SERVICES_FETCH_DROPDOWN_REQUEST = 'SERVICES_FETCH_DROPDOWN_REQUEST';
export const SERVICES_FETCH_DROPDOWN_REQUEST_SUCCESS = 'SERVICES_FETCH_DROPDOWN_REQUEST_SUCCESS';
export const SERVICES_FETCH_DROPDOWN_REQUEST_FAILURE = 'SERVICES_FETCH_DROPDOWN_REQUEST_FAILURE';

export const SERVICES_CLEAN_REQUEST = 'SERVICES_CLEAN_REQUEST';
